class BundleComponent extends HTMLElement {
    form;
    numbers;
    constructor() {
        super();
        this.form = this.querySelector('#bundle-form');
        this.numbers = this.querySelectorAll('.bundle_input-number');
        this.form.addEventListener('submit', this.handleForm.bind(this));
    }
    handleForm(e) {
        e.preventDefault();
        const submitButton = this.form.querySelector('[type="submit"]');
        const drawer = this.closest('.menu-drawer');
        const numbers = this.numbers;
        submitButton.setAttribute('disabled', 'true');
        submitButton.classList.add('loading');
        const data = JSON.parse(window.theme.utils.serializeForm(this.form));
        const body = JSON.stringify({
            items: [
                {
                    id: data['items[0][id]'],
                    properties: {
                        '_bundle': data['items[0][properties][_bundle]']
                    }
                },
                {
                    id: data['items[1][id]'],
                    properties: {
                        '_bundle': data['items[1][properties][_bundle]']
                    }
                },
            ],
        });
        fetch('/cart/add', { ...window.theme.fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((parsedState) => {
                drawer.removeAttribute('open');
                window.theme.bundle.drawer(1);
                const number = parseInt(numbers[0].value) + 1;
                numbers.forEach((el) => { el.value = number.toString(); });
                window.theme.cart.render(true);
            })
            .catch((err) => {
                console.error(err);
                e.target.submit();
            })
            .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
            });
    }
}
customElements.define('bundle-component', BundleComponent);
class BundleForm extends HTMLElement {
    product;
    currentVariant;
    swatch;
    input;
    option1;
    option2;
    image;
    button;
    elements;
    item;
    subtotal;
    total;
    options;
    constructor() {
        super();
        this.product = window.theme.bundle['product-' + this.dataset.index];
        this.currentVariant = this.product.currentVariant;
        this.swatch = this.querySelector('#variantPicker');
        this.input = this.querySelector('.bundle_input-id');
        this.option1 = this.swatch.querySelector('.product_option1-value');
        this.option2 = this.swatch.querySelector('.product_option2-value');
        this.image = this.querySelector('img');
        this.button = document.querySelector('bundle-component .product-form__submit');
        this.elements = document.querySelectorAll('bundle-form');
        this.item = document.querySelector('#bundle-form [data-item="' + this.dataset.index + '"]');
        this.subtotal = document.querySelector('#bundle-form [data-subtotal]');
        this.total = document.querySelector('#bundle-form [data-total]');
        this.swatch.addEventListener('change', this.onVariantChange.bind(this));
    }
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantInput();
        this.image.src = this.currentVariant.image;
        this.product.currentVariant = this.currentVariant;
        this.changeElements();
    }
    updateOptions() {
        const fieldsets = Array.from(this.swatch.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value);
    }
    updateMasterId() {
        const oldSizes = this.currentVariant.sizes.join(',');
        this.currentVariant = this.product.variants.find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
        if (!this.currentVariant)
            this.currentVariant = this.product.variants.find((variant) => variant.options[0] === this.options[0]);
        if (this.currentVariant.sizes.join(',') !== oldSizes) {
            const input = this.querySelector('input[value="' + this.currentVariant.options[1] + '"]');
            input.click();
            this.options = this.currentVariant.options;
            const sizeInputs = this.querySelectorAll('input[name="Weight (lbs)' + this.dataset.index + '"]');
            for (let index = 0; index < sizeInputs.length; index++) {
                const sizeInput = sizeInputs[index];
                const label = sizeInput.nextElementSibling;
                if (this.currentVariant.sizes.includes(sizeInput.value))
                    label.removeAttribute('hidden');
                else
                    label.setAttribute('hidden', '');
            }
        }
    }
    updateVariantInput() {
        this.input.value = this.currentVariant.id;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    checkAvailability() {
        if (this.currentVariant.available)
            this.removeAttribute('soldout');
        else
            this.setAttribute('soldout', '');
    }
    changeElements() {
        this.option1.innerHTML = this.currentVariant.options[0];
        this.item.querySelector('[data-color]').dataset.color = this.currentVariant.options[0];
        this.option2.innerHTML = this.currentVariant.options[1] + ' lbs (' + window.theme.dimensions[this.currentVariant.options[1]] + ')';
        this.item.querySelector('[data-weight]').dataset.weight = this.currentVariant.options[1] + ' lbs';
        this.item.querySelector('img').src = this.currentVariant.image;
        const itemPrice = this.currentVariant.price / 100;
        this.item.querySelector('[data-price]').dataset.price = '$' + itemPrice;
        let price = 0;
        this.elements.forEach((element) => {
            price += element.currentVariant.price;
        });
        price = price / 100;
        this.subtotal.dataset.subtotal = '$' + price;
        price = price - window.theme.bundle.discount;
        this.total.dataset.total = '$' + price;
        this.button.dataset.mobilePrice = '$' + price;
    }
}
customElements.define('bundle-form', BundleForm);